import React, { useState } from 'react'
import { DateRange } from 'react-date-range'
import { Button, Col, Modal, ModalBody, ModalFooter, Row, Spinner } from 'reactstrap'

function SelectDateSyncData({ isOpen, onClose, onChangeRangeDate }) {
  const [rangeDate, setRangeDate] = useState([
    {
      startDate: new Date(),
      endDate: new Date(),
      key: 'selection',
    },
  ])
  const [submitting, setSubmitting] = useState(false)

  const handleSelectDate = (ranges) => {
    const { startDate, endDate } = ranges.selection
    setRangeDate([{ startDate, endDate, key: 'selection' }])
  }

  const handleSubmitDate = async () => {
    setSubmitting(true)
    try {
      await Promise.resolve(onChangeRangeDate(rangeDate))
    } finally {
      setSubmitting(false)
    }
  }

  return (
    <Modal isOpen={isOpen} toggle={onClose}>
      <ModalBody>
        <DateRange
          editableDateInputs={true}
          moveRangeOnFirstSelection={false}
          onChange={handleSelectDate}
          ranges={rangeDate}
          className='w-100'
        />
      </ModalBody>
      <ModalFooter>
        <Row>
          <Col>
            <Button
              color='primary'
              role='button'
              onClick={handleSubmitDate}
              disabled={submitting}
            >
              {submitting ? (
                <>
                  <Spinner size='sm' className='me-2' /> Loading...
                </>
              ) : (
                'Ok'
              )}
            </Button>
          </Col>
          <Col>
            <button
              className='bg-transparent text-black btn-cancel-calendar'
              type='button'
              onClick={onClose}
              disabled={submitting}
            >
              Cancel
            </button>
          </Col>
        </Row>
      </ModalFooter>
    </Modal>
  )
}

export default SelectDateSyncData
